import axios from "axios";
import { useEffect, useState } from "react";
import Navbar from "../components/Navbar";

import API from "../config.js";
const G    = "#FFB800";
const G2   = "#FFD700";
const GD   = "#C8860A";

const TYPE_META = {
  deposit:         { label: "Deposit",         color: "#00e87a", icon: "↑" },
  withdraw:        { label: "Withdraw",         color: "#ff6b6b", icon: "↓" },
  interest:        { label: "Daily Interest",   color: "#00e87a", icon: "✦" },
  invest:          { label: "Invest",           color: G,         icon: "⬈" },
  invest_withdraw: { label: "Capital Withdraw", color: "#ff6b6b", icon: "↩" },
  referral_bonus:  { label: "Referral Bonus",   color: G2,        icon: "★" },
  level_income:    { label: "Level Income",     color: G,         icon: "⬡" },
  manual_credit:   { label: "Manual Credit",    color: "#00e87a", icon: "+" },
  manual_debit:    { label: "Manual Debit",     color: "#ff6b6b", icon: "−" },
};

const STATUS_META = {
  completed: { color: "#00e87a",  bg: "rgba(0,232,122,0.07)",  border: "rgba(0,232,122,0.2)"  },
  pending:   { color: G,          bg: "rgba(255,184,0,0.07)",  border: "rgba(255,184,0,0.2)"  },
  approved:  { color: G2,         bg: "rgba(255,215,0,0.07)",  border: "rgba(255,215,0,0.2)"  },
  rejected:  { color: "#ff6b6b",  bg: "rgba(255,107,107,0.07)", border: "rgba(255,107,107,0.2)" },
};

// Types that ADD to the user's money (show with +). Everything else shows −.
const CREDIT_TYPES = ["deposit", "interest", "referral_bonus", "level_income", "manual_credit", "invest_withdraw"];

export default function Transactions() {
  const [txns,    setTxns]    = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter,  setFilter]  = useState("all");

  const token = localStorage.getItem("token");

  useEffect(() => {
    if (!token) { window.location.href = "/"; return; }
    axios.get(`${API}/api/transactions`, {
      headers: { Authorization: "Bearer " + token },
    }).then(res => {
      const d = res.data;
      setTxns(Array.isArray(d) ? d : d.transactions || []);
    }).catch((err) => {
      // Only redirect on 401 (invalid/expired token), not on network/server errors
      if (err.response && err.response.status === 401) {
        localStorage.removeItem("token");
        window.location.href = "/";
      }
    }).finally(() => setLoading(false));
  }, []);

  const filtered = filter === "all" ? txns : txns.filter(t => t.type === filter);

  const summary = txns.reduce((acc, t) => {
    const amt = Number(t.amount) || 0;
    if (t.type === "deposit")                           acc.dep  += amt;
    if (t.type === "withdraw")                          acc.with += amt;
    if (["referral_bonus","level_income"].includes(t.type)) acc.earn += amt;
    return acc;
  }, { dep: 0, with: 0, earn: 0 });

  return (
    <div style={s.page}>
      <Navbar />
      <div style={s.container} className="page-container">

        {/* Header */}
        <div style={s.header} className="page-header">
          <div>
            <h1 style={s.title}>Transactions</h1>
            <p style={s.sub}>Your complete transaction history</p>
          </div>
          <div style={s.countBadge}>
            <span style={s.countNum}>{txns.length}</span>
            <span style={s.countLbl}>records</span>
          </div>
        </div>

        {/* Summary Strip */}
        <div style={s.summaryRow}>
          <SumCard label="Total Deposited"  value={fmt(summary.dep)}  color="#00e87a" icon="↑" />
          <SumCard label="Total Withdrawn"  value={fmt(summary.with)} color="#ff6b6b" icon="↓" />
          <SumCard label="Total Earned"     value={fmt(summary.earn)} color={G2}      icon="★" />
        </div>

        {/* Filter Bar */}
        <div style={s.filterBar} className="tx-filters">
          {["all","deposit","withdraw","referral_bonus","level_income"].map(f => (
            <button key={f}
              style={{ ...s.filterBtn, ...(filter === f ? s.filterActive : {}) }}
              onClick={() => setFilter(f)}>
              {f === "all" ? "All" : (TYPE_META[f]?.label || f)}
            </button>
          ))}
        </div>

        {/* Table */}
        <div style={s.tableWrap}>
          {/* Gold top accent */}
          <div style={s.tableTopLine} />

          {loading ? (
            <div style={s.center}>
              <div style={s.spinner} />
              <span style={{ color: "rgba(200,160,60,0.5)", fontFamily: "'-apple-system','BlinkMacSystemFont','Figtree', sans-serif", fontSize: 13 }}>
                Loading transactions...
              </span>
            </div>
          ) : filtered.length === 0 ? (
            <div style={s.center}>
              <div style={s.emptyIcon}>◫</div>
              <div style={s.emptyText}>No transactions found</div>
              <div style={s.emptySub}>
                {filter !== "all" ? "Try a different filter." : "Make your first deposit to get started."}
              </div>
            </div>
          ) : (
            <div style={{ overflowX: "auto" }}>
              <table style={s.table}>
                <thead>
                  <tr>
                    {["#","Type","Amount","Fee","Status","Note","Date"].map(h => (
                      <th key={h} style={s.th}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {filtered.map((t, i) => {
                    const meta = TYPE_META[t.type] || { label: t.type, color: G, icon: "○" };
                    const sm   = STATUS_META[t.status] || STATUS_META.completed;
                    const credit = CREDIT_TYPES.includes(t.type);
                    return (
                      <tr key={i} style={{ ...s.tr, ...(i % 2 === 0 ? s.trEven : {}) }}>
                        <td style={s.td}>
                          <span style={s.rowNum}>{i + 1}</span>
                        </td>
                        <td style={s.td}>
                          <div style={s.typeCell}>
                            <span style={{ ...s.typeIcon,
                              color: meta.color,
                              background: meta.color + "12",
                              borderColor: meta.color + "30" }}>
                              {meta.icon}
                            </span>
                            <span style={{ ...s.typeLabel, color: meta.color }}>{meta.label}</span>
                          </div>
                        </td>
                        <td style={s.td}>
                          <span style={{ ...s.amtText, color: credit ? "#00e87a" : "#ff6b6b" }}>
                            {credit ? "+" : "−"} {fmt2(t.amount)} USDT
                          </span>
                        </td>
                        <td style={s.td}>
                          <span style={s.feeText}>
                            {t.fee ? `${fmt2(t.fee)} USDT` : <span style={s.dash}>—</span>}
                          </span>
                        </td>
                        <td style={s.td}>
                          <span style={{ ...s.badge,
                            color: sm.color, background: sm.bg, borderColor: sm.border }}>
                            {t.status || "completed"}
                          </span>
                        </td>
                        <td style={s.td}>
                          <span style={s.note}>{t.note || <span style={s.dash}>—</span>}</span>
                        </td>
                        <td style={s.td}>
                          <span style={s.date}>{fmtDate(t.date)}</span>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

function SumCard({ label, value, color, icon }) {
  return (
    <div style={{ ...s.sumCard, borderColor: color + "20" }}>
      <span style={{ ...s.sumIcon, color, background: color + "0e" }}>{icon}</span>
      <div>
        <div style={{ ...s.sumVal, color }}>{value}</div>
        <div style={s.sumLbl}>{label}</div>
      </div>
    </div>
  );
}

const fmt  = v => "USDT " + (Number(v)||0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const fmt2 = v => (Number(v)||0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const fmtDate = d => {
  if (!d) return "—";
  return new Date(d).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
};

const s = {
  page:      { minHeight: "100vh", background: "#03050a" },
  container: { maxWidth: 1200, margin: "0 auto", padding: "32px 24px" },
  header: {
    display: "flex", justifyContent: "space-between",
    alignItems: "flex-end", marginBottom: 24,
    flexWrap: "wrap", gap: 12,
  },
  title: {
    fontFamily: "'Figtree', sans-serif",
    fontWeight: 700, fontSize: 28,
    background: `linear-gradient(135deg, #f0e0a0, ${G}, ${GD})`,
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    letterSpacing: 2, marginBottom: 6,
  },
  sub: {
    fontFamily: "'-apple-system','BlinkMacSystemFont','Figtree', sans-serif",
    fontSize: 14, color: "rgba(200,160,60,0.55)",
  },
  countBadge: { textAlign: "right" },
  countNum: {
    fontFamily: "'Figtree', sans-serif",
    fontWeight: 700, fontSize: 28, color: G,
    display: "block",
  },
  countLbl: {
    fontFamily: "'-apple-system','BlinkMacSystemFont','Figtree', sans-serif",
    fontSize: 11, color: "rgba(200,160,60,0.4)",
    letterSpacing: 1.5, textTransform: "uppercase",
  },
  summaryRow: { display: "flex", gap: 12, flexWrap: "wrap", marginBottom: 20 },
  sumCard: {
    flex: 1, minWidth: 180,
    background: "rgba(10,8,3,0.95)",
    border: "1px solid", borderRadius: 10,
    padding: "14px 18px",
    display: "flex", alignItems: "center", gap: 12,
  },
  sumIcon: {
    width: 32, height: 32, borderRadius: 6,
    display: "flex", alignItems: "center",
    justifyContent: "center",
    fontSize: 16, fontWeight: 700, flexShrink: 0,
  },
  sumVal: {
    fontFamily: "'Figtree', sans-serif",
    fontWeight: 700, fontSize: 15, marginBottom: 2,
  },
  sumLbl: {
    fontFamily: "'-apple-system','BlinkMacSystemFont','Figtree', sans-serif",
    fontSize: 11, color: "rgba(200,160,60,0.5)",
    textTransform: "uppercase", letterSpacing: 0.5,
  },
  filterBar: { display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 16 },
  filterBtn: {
    fontFamily: "'-apple-system','BlinkMacSystemFont','Figtree', sans-serif",
    fontWeight: 600, fontSize: 12,
    color: "rgba(200,160,60,0.55)",
    background: "rgba(10,8,3,0.9)",
    border: "1px solid rgba(255,184,0,0.08)",
    borderRadius: 6, padding: "7px 14px",
    cursor: "pointer", letterSpacing: 0.5,
    transition: "all 0.2s",
  },
  filterActive: {
    color: G,
    background: "rgba(255,184,0,0.1)",
    border: "1px solid rgba(255,184,0,0.3)",
  },
  tableWrap: {
    background: "rgba(10,8,3,0.97)",
    border: "1px solid rgba(255,184,0,0.1)",
    borderRadius: 12, overflow: "hidden",
    boxShadow: "0 4px 30px rgba(0,0,0,0.4)",
    position: "relative",
  },
  tableTopLine: {
    height: 2,
    background: `linear-gradient(90deg, transparent, ${G2}, ${G}, ${GD}, transparent)`,
  },
  table: { width: "100%", borderCollapse: "collapse" },
  th: {
    fontFamily: "'-apple-system','BlinkMacSystemFont','Figtree', sans-serif",
    fontWeight: 700, fontSize: 11,
    color: "rgba(255,184,0,0.55)",
    letterSpacing: 1, textTransform: "uppercase",
    padding: "14px 16px", textAlign: "left",
    background: "rgba(0,0,0,0.3)",
    borderBottom: "1px solid rgba(255,184,0,0.07)",
    whiteSpace: "nowrap",
  },
  tr:     { borderBottom: "1px solid rgba(255,184,0,0.04)" },
  trEven: { background: "rgba(255,184,0,0.012)" },
  td: {
    padding: "13px 16px",
    fontFamily: "'-apple-system','BlinkMacSystemFont','Figtree', sans-serif",
    fontSize: 13, verticalAlign: "middle",
  },
  rowNum: {
    fontFamily: "'Figtree', sans-serif",
    fontSize: 11, color: "rgba(200,160,60,0.25)",
  },
  typeCell: { display: "flex", alignItems: "center", gap: 8 },
  typeIcon: {
    width: 26, height: 26, borderRadius: 6,
    border: "1px solid", display: "flex",
    alignItems: "center", justifyContent: "center",
    fontSize: 13, fontWeight: 700, flexShrink: 0,
  },
  typeLabel: {
    fontWeight: 600, fontSize: 12, letterSpacing: 0.3, whiteSpace: "nowrap",
  },
  amtText: {
    fontFamily: "'Figtree', sans-serif",
    fontWeight: 700, fontSize: 13, letterSpacing: 0.5,
  },
  feeText: {
    fontFamily: "'-apple-system','BlinkMacSystemFont','Figtree', sans-serif",
    fontSize: 13, color: "rgba(200,160,60,0.55)",
  },
  badge: {
    fontFamily: "'-apple-system','BlinkMacSystemFont','Figtree', sans-serif",
    fontWeight: 700, fontSize: 10,
    letterSpacing: 0.8, textTransform: "uppercase",
    padding: "3px 8px", borderRadius: 4,
    border: "1px solid", display: "inline-block",
    whiteSpace: "nowrap",
  },
  note: {
    fontFamily: "'-apple-system','BlinkMacSystemFont','Figtree', sans-serif",
    fontSize: 12, color: "rgba(200,160,60,0.55)",
    maxWidth: 160, overflow: "hidden",
    textOverflow: "ellipsis", whiteSpace: "nowrap",
    display: "block",
  },
  date: {
    fontFamily: "'-apple-system','BlinkMacSystemFont','Figtree', sans-serif",
    fontSize: 12, color: "rgba(200,160,60,0.5)",
    whiteSpace: "nowrap",
  },
  dash: { color: "rgba(200,160,60,0.2)" },
  center: {
    padding: "60px",
    display: "flex", flexDirection: "column",
    alignItems: "center", gap: 12,
  },
  spinner: {
    width: 36, height: 36,
    border: "3px solid rgba(255,184,0,0.1)",
    borderTop: `3px solid ${G}`,
    borderRadius: "50%",
    animation: "spin 0.8s linear infinite",
    boxShadow: "0 0 16px rgba(255,184,0,0.12)",
  },
  emptyIcon: {
    fontSize: 52, color: "rgba(255,184,0,0.12)", marginBottom: 12,
  },
  emptyText: {
    fontFamily: "'Figtree', sans-serif",
    fontWeight: 600, fontSize: 16,
    color: "rgba(200,160,60,0.4)",
    marginBottom: 8,
  },
  emptySub: {
    fontFamily: "'-apple-system','BlinkMacSystemFont','Figtree', sans-serif",
    fontSize: 13, color: "rgba(200,160,60,0.3)",
  },
};




